var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnEmailBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6797 13.8125C23.1327 13.8125 23.5 13.4452 23.5 12.9922V6.92188C23.5 5.11259 22.028 3.64062 20.2188 3.64062H5.78125C3.97197 3.64062 2.5 5.11259 2.5 6.92188V18.0781C2.5 19.8874 3.97197 21.3594 5.78125 21.3594H20.2188C22.028 21.3594 23.5 19.8874 23.5 18.0781V17.9141C23.5 17.6657 23.3875 17.4307 23.194 17.275L16.9837 12.2766L21.8594 9.24479V12.9922C21.8594 13.4452 22.2266 13.8125 22.6797 13.8125ZM4.14062 9.24479L9.015 12.2758L4.14062 16.1881V9.24479ZM21.8451 18.2953C21.7385 19.0977 21.0498 19.7188 20.2188 19.7188H5.78125C4.94556 19.7188 4.25379 19.0907 4.15322 18.2818L10.4919 13.1941L11.2673 13.6763C12.336 14.341 13.6639 14.3409 14.7327 13.6763L15.5075 13.1945L21.8451 18.2953ZM13.8664 12.2831C13.332 12.6154 12.6681 12.6154 12.1337 12.2831L4.16363 7.32715C4.15601 7.32239 4.14834 7.31784 4.14062 7.31337V6.92188C4.14062 6.01723 4.87661 5.28125 5.78125 5.28125H20.2188C21.1234 5.28125 21.8594 6.01723 21.8594 6.92188V7.31284L13.8664 12.2831Z",
    fill: "#1E3799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEmailBlue);
export default __webpack_public_path__ + "static/media/icn_email_blue.ecb2458174319e895c453ff3ee73a4df.svg";
export { ForwardRef as ReactComponent };